import { ModelSchema } from "simple-schema-model-validator";

export class LoginSchema extends ModelSchema {
    constructor () {
        const schemaModel = {
            "uswLogin": {
                "alias": "Rut o email", 
                "type": "string",
                "required": true
            },
            "uswClave": {
                "alias": "Contraseña",
                "type": "string",
                "required": true
            }
        }

        super(schemaModel);
    }
}